import React from 'react'
import {
	connect as formikConnect,
	FieldArray
} from 'formik'
import {
	FieldGroup,
	fieldPresets
} from '@modules/form/form.module'
import objectPath from 'object-path'

const getEmptyAddress = () => ({
	line1: '',
	line2: '',
	townCity: '',
	country: '',
	postCode: '',
	from: null,
	to: null,
})


@formikConnect
class AddressHistoryField extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			previousAddress: null,
			isCurrentLiveHereChoosen: false,
		};
	}
	render() {
		const { name, formik, isEditing } = this.props;
		const values = formik.values[this.props.name];
		const addressHistory = formik.values.addressHistory
		const lastAdressField = addressHistory[addressHistory.length - 1]
		return (
			<FieldArray name={name} render={arrayHelpers => (
				<div className="AddressHistory">

					<div className="AddressHistory-forms">

						{
							values.map((v, i) => <div className="AddressHistory-form">{this.renderAddress(i, i && isEditing ? arrayHelpers.remove : undefined)}	</div>)
						}
					</div>
					{
						isEditing && lastAdressField.from &&
						<div className="AddressHistory-buttonWrap">
							<button type="button" className="btn btn-primary" onClick={() => { arrayHelpers.push(getEmptyAddress()) }}>Add address</button>
						</div>
					}
				</div>
			)} />
		)
	}


	onCurrentLiveHereClick = () => {
		this.setState({
			isCurrentLiveHereChoosen: !this.state.isCurrentLiveHereChoosen,
		});
	}

	renderAddress(index, remove) {
		const { name, isEditing, formik } = this.props;
		const prefix = `${name}.${index}`;
		const addressFields = fieldPresets([
			['address.line1', {
				name: `${prefix}.line1`,
			}],
			['address.line2', {
				name: `${prefix}.line2`,
			}],
			['address.townCity', {
				name: `${prefix}.townCity`,
			}],
			['address.country', {
				name: `${prefix}.country`,
			}],
			['address.postCode', {
				name: `${prefix}.postCode`,
			}],
		]);

		const currentValues = objectPath.get(formik.values, `${prefix}`);

		// TODO: move time labels
		const dateFields = [
			{
				label: 'Date moved in (mm/yyyy)',
				name: `${prefix}.from`,
				component: 'DatePicker',
				maxDate: currentValues.to ? new Date(currentValues.to) : new Date(),
				dateFormat: "MM/yyyy",
				showMonthYearPicker: true,
				popperPlacement: 'top',
				disableKeyboardNavigation: true,
				setPreviousAddress: (value) => this.setState({
					previousAddress: value,
				})
			},
			{
				label: 'Date moved out (mm/yyyy)',
				name: `${prefix}.to`,
				component: 'DatePicker',
				minDate: currentValues.from ? new Date(currentValues.from) : null,
				maxDate: new Date(),
				dateFormat: "MM/yyyy",
				showMonthYearPicker: true,
				popperPlacement: 'top',
				disableKeyboardNavigation: true,

				// displaying move out date from previous address history field
				previousAddress: this.state.previousAddress,

				// passing current move in date to the child's state
				setDisableToParrent: this.onCurrentLiveHereClick,
			}
		];

		const label = index ? `Previous address ${index}` : 'Current address';
		return (
			<React.Fragment key={index}>
				<p><b>{label}</b></p>
				{remove &&
					<div className="AddressHistory-buttonWrap">
						<button type="button" className="btn btn-primary" onClick={() => remove(index)}>Remove address</button>
					</div>
				}
				{addressFields.map(props =>
					<FieldGroup key={props.name} isEditing={isEditing} {...props} />
				)}

				{dateFields.map((props) =>
					<FieldGroup showMonthYearPicker key={props.name} isEditing={isEditing} {...props} />
				)}
			</React.Fragment>
		)
	}
}

export default AddressHistoryField;


// WEBPACK FOOTER //
// ./src/modules/form/components/input/AddressHistory.jsx